import { useQuery } from '@tanstack/react-query';

import { getLiveAnalysis } from '@data';

import { useActivity } from './useActivity';

export const getLiveAnalysisKey = (activityId: number) => ['activity', activityId, 'live-feedback', 'analysis'];

export const useLiveAnalysis = (activityId: number) => {
    const { data: activity } = useActivity(activityId);

    return useQuery({
        queryKey: getLiveAnalysisKey(activityId),
        queryFn: () => getLiveAnalysis({ activityId }),
        refetchInterval: 5_000,
        enabled: !!activity,
        retry: 5,
    });
};
